/*
 * The DS breakpoints: tailwind.config.js registers them as `ds-narrow:` etc.,
 * and code that needs the same threshold in a media query imports them here.
 */
export const DS_SCREENS = {
  'ds-narrow': '450px',
  'ds-pair': '1150px',
  // Wide enough that the map is tall enough to hold the weather card.
  'ds-map-overlay': '1266px',
};
